var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgXiaoxi = function SvgXiaoxi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "xiaoxi_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCC4A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBAF0F",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#xiaoxi_svg__a)",
    width: 32,
    height: 32,
    rx: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9a2 2 0 0 0-2 2v8.79a2 2 0 0 0 2 2h5.248l4.428 2.154c.075.044.16.056.245.056a.5.5 0 0 0 .509-.49l-.255-1.72H22a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2H10Zm9.355 5.383c.628 0 1.138.51 1.138 1.14a1.138 1.138 0 1 1-2.274 0c0-.63.509-1.14 1.136-1.14Zm-3.41 0c.628 0 1.137.51 1.137 1.14a1.138 1.138 0 1 1-2.274 0c0-.63.509-1.14 1.137-1.14Zm-3.411 0c.628 0 1.137.51 1.137 1.14 0 .629-.51 1.139-1.137 1.139-.628 0-1.137-.51-1.137-1.14 0-.629.509-1.14 1.137-1.14Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
};

export default SvgXiaoxi;